module.exports = __webpack_public_path__ + "static/media/Group 28.ad98646a.svg";